export default __webpack_public_path__ + "assets/webgl/scene-21.d3a7af72.glb";